// extracted by mini-css-extract-plugin
export default {"error":"H","errorContents":"I","errorLogo":"J"};